import React, { FC } from 'react';
import { ABody, ABodySize, ABodyColor, AIcon, AIconSize } from '@marriott/mi-web-ui-kit';
import * as Styled from './ChatDisclaimer.styles';
import * as DisclaimerLayout from './ChatDisclaimerLayout.styles';
import { ChatDisclaimerProps } from './ChatDisclaimer.types';

const ChatDisclaimer: FC<ChatDisclaimerProps> = ({
  className,
  enabled = true,
  text,
  disclaimerContext = 'chat',
  layout = 'none',
  onDismiss,
  regionAriaLabel = 'Chat disclaimer',
  closeButtonAriaLabel = 'Close disclaimer',
}) => {
  if (!enabled) {
    return null;
  }

  const defaultText =
    'By entering a prompt, you consent to Marriott and its third-party service providers monitoring, recording, and/or retaining information in the chat for quality and training purposes. Please do not submit any Personal Data into the chat. Please review our';

  const disclaimerBody = (
    <Styled.DisclaimerWrapper className={className}>
      <Styled.DisclaimerContent $context={disclaimerContext}>
        <ABody bodyText={`${text || defaultText} `} size={ABodySize.XS} color={ABodyColor.Alternate} />
      </Styled.DisclaimerContent>
    </Styled.DisclaimerWrapper>
  );

  switch (layout) {
    case 'none':
      return disclaimerBody;
    case 'desktop-under-input':
      return <DisclaimerLayout.DesktopUnderInput>{disclaimerBody}</DisclaimerLayout.DesktopUnderInput>;
    case 'mobile-top-bar':
      return <DisclaimerLayout.MobileTopBar>{disclaimerBody}</DisclaimerLayout.MobileTopBar>;
    case 'mobile-messages-inline':
      return <DisclaimerLayout.MobileMessagesInline>{disclaimerBody}</DisclaimerLayout.MobileMessagesInline>;
    case 'welcome-desktop-footer':
      return <DisclaimerLayout.WelcomeDesktopFooter>{disclaimerBody}</DisclaimerLayout.WelcomeDesktopFooter>;
    case 'dismissible-welcome-mobile':
      return (
        <DisclaimerLayout.DismissibleWelcomeMobileCard role="region" aria-label={regionAriaLabel}>
          <DisclaimerLayout.DismissibleWelcomeMobileClose
            type="button"
            aria-label={closeButtonAriaLabel}
            onClick={onDismiss}
          >
            <AIcon icon="icon-clear" size={AIconSize.M} aria-hidden="true" />
          </DisclaimerLayout.DismissibleWelcomeMobileClose>
          {disclaimerBody}
        </DisclaimerLayout.DismissibleWelcomeMobileCard>
      );
    default: {
      const _exhaustive: never = layout;
      return _exhaustive;
    }
  }
};

export { ChatDisclaimer };
export type { ChatDisclaimerProps, ChatDisclaimerContext, ChatDisclaimerLayout } from './ChatDisclaimer.types';
